import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'ToiSubscriptionLoader' */ './ToiSubscriptionFlowCaller'),
  loading: () => null,
});

export default class ToiSubscriptionLoader extends React.Component {
  render() {
    return <LoadableComponent {...this.props} />;
  }
}
